import { countryPhoneLengths, FETCHERROR, TRUEVALUE } from "../helpers/Config";
import axios from "axios";
import { getToken } from "./get-token";
import { setShowBookingIdAlert, setShowMessageObj } from "../store/userSlice";
import { trackMixpanel } from "../services/mixpanel";

export const validNumber = (value, setValue) => {
  if (/^\d+$/.test(value)) {
    setValue(value);
  } else {
    setValue("");
  }
};

export const validEmail = (value) => {
  return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(
    value
  );
};

export const validatePassword = (password) => {
  const regex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}":;'?<>.,~\/-])[A-Za-z\d!@#$%^&*()_+{}":;'?<>.,~\/-]{8,}$/;
  return regex.test(password);
};

export const validatePhone = (value, country) => {
  const maxLength = countryPhoneLengths[country];
  if (maxLength) {
    return value.length < maxLength ? false : true;
  } else {
    return true;
  }
};

export const fetchGetData = async (url) => {
  try {
    const token = getToken();
    // let data = await axios.get(`${process.env.REACT_APP_BASE_URL}${url}`);
    // let data = await axios.get(`http://localhost:3001/api${url}`);
    // let data = await axios.get(`https://api.exto.auction/api${url}?token=${getToken()}`);
    let data = await axios.get(`${process.env.REACT_APP_BASE_URL}${url}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (error) {
    console.error("Error:", error);
    trackMixpanel(FETCHERROR, {
      errorMessage: error,
      timestamp: new Date().toISOString(),
    });
    if (error?.response?.data?.message?.length) {
      return error?.response?.data.message;
    } else if (error?.response?.message?.length) {
      return error?.response?.message;
    } else {
      return null;
    }
  }
};

export const fetchRequest = async (
  method,
  url,
  data,
  catchFunc = null,
  finallyFunc = null
) => {
  try {
    const token = getToken();
    // const response = axiosServices.post(`${process.env.REACT_APP_BASE_URL}${url}`, data)
    const response = await axios({
      // url: `${process.env.REACT_APP_BASE_URL}${url}`,
      // url: `http://localhost:3001/api${url}`,
      url: `${process.env.REACT_APP_BASE_URL}${url}`,
      method: method,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error:", error);
    trackMixpanel(FETCHERROR, {
      errorMessage: error,
      timestamp: new Date().toISOString(),
    });
    if (catchFunc) {
      catchFunc(error);
    }
    console.error("Error:", error);
    if (error?.response?.data?.message?.length) {
      return error?.response?.data.message;
    } else if (error?.response?.message?.length) {
      return error?.response?.message;
    } else {
      return null;
    }
  } finally {
    if (finallyFunc) {
      finallyFunc();
    }
  }
};

export const handleExit = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("notFirstLogin");
  window.location.assign("auth/login");
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler("onLogout", "");
  }
};

export const handleSaveMedia = async (files, dispatch) => {
  const token = getToken();
  let formData = new FormData();
  // formData.append('images', files);
  // formData.append('file', files);

  for (let i = 0; i < files.length; i++) {
    formData.append("images", files[i]);
  }

  return await fetch(
    `${process.env.REACT_APP_BASE_URL}/v1/public/images/upload`,
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      if (res?.imageUrls?.length) {
        return res.imageUrls;
      } else {
        dispatch(
          setShowMessageObj({
            open: true,
            status: "error",
            message: res?.message,
          })
        );
        return "";
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      return "";
    });
};

export const handleRandomId = () => {
  return `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
};

export const formatTime = (dateString) => {
  const date = new Date(dateString); // Конвертуємо строку у Date
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const handleCheckBoxSettings = (arr, name) => {
  if (arr?.length && arr.find((el) => el.key === name)) {
    return arr.find((el) => el.key === name)?.value === TRUEVALUE
  }
  return true;
};

export const handleCloseBookingIdAlert = (dispatch) => {
  dispatch(setShowBookingIdAlert(false));
  localStorage.removeItem("bookingId");
}
